import PropTypes from "prop-types";
import { Media } from "solar/components/Media";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import Markdown from "solar/components/Markdown";
import styles from "components/destination/Story.module.scss";

export default function Story({ name, description }) {
  return (
    <div className={styles.component}>
      <Title tag="h1" size={3}>
        {name}
      </Title>
      {description && (
        <Text className={styles.description}>
          <Media lessThan="md">
            <Markdown truncate more>
              {description}
            </Markdown>
          </Media>
          <Media greaterThanOrEqual="md">
            <Markdown truncate more>
              {description}
            </Markdown>
          </Media>
        </Text>
      )}
    </div>
  );
}

Story.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
};
